import Client from './client';

export default class BankPayments extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/bank/payments`, options);
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/bank/payments/${id}`, options);
  }

  deleteById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/bank/payments/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

  putStatusById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/bank/payments/${id}/status`, {
      ...options,
       method: 'PUT',
    });
  }

  putByKey(key, options = {}) {
    return this.makeRequest(`${this.host}/internal/bank/payments/${key}`, {
      ...options,
       method: 'PUT',
    });
  }

}
